<template>
  <section
    v-if="microsite?.reward1Photo || microsite?.reward2Photo || microsite?.reward3Photo || microsite?.reward4Photo"
    class="cooperation"
  >
    <div>
      <h2>Spolupráce a ocenění</h2>
      <div>
        <div class="logos">
          <a
            v-if="microsite?.reward1Photo && microsite?.showReward1"
            :href="microsite?.reward1Photo"
          >
            <img
              :src="microsite?.reward1Photo"
              alt=""
            >
          </a>

          <a
            v-if="microsite?.reward2Photo && microsite?.showReward2"
            :href="microsite?.reward2Photo"
          >
            <img
              :src="microsite?.reward2Photo"
              alt=""
            >
          </a>

          <a
            v-if="microsite?.reward3Photo && microsite?.showReward3"
            :href="microsite?.reward3Photo"
          >
            <img
              :src="microsite?.reward3Photo"
              alt=""
            >
          </a>

          <a
            v-if="microsite?.reward4Photo && microsite?.showReward4"
            :href="microsite?.reward4Photo"
          >
            <img
              :src="microsite?.reward4Photo"
              alt=""
            >
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMicrositeStore } from '../../stores/useMicrositeStore'

const store = useMicrositeStore()

const microsite = computed(() => {
  return store.microsite
})
</script>
